module.exports = __webpack_public_path__ + "static/img/nodata.1e95b6c2.png";